import { SF_LETTERS, SF_LINK_WORDS, type SfLetter } from './row-key.js';

/** THE SALESFORCE LINKS (ported 2026-10-18 from the medrec console's components/list/SfLinks.tsx, its design plan's Lane 1; DESIGN_SYSTEM 7):
 *  letter keys, 24 px squares, in one order everywhere. Sweet Claims' own records: M (the Matter) and I (this insurance record). Each is a
 *  link that opens a new tab, its hover "Open the Matter in Salesforce (new tab)" and its spoken name the same; a record the row holds no
 *  link for keeps its place, empty and hidden, so the column's letters line up row under row. The hrefs come from `sfHrefs` (the one URL
 *  rule), never built here. */
export function SfLinks({ hrefs }: { hrefs: Readonly<Partial<Record<SfLetter, string | null>>> }) {
  return (
    <span className="lp-links" data-testid="sf-links">
      {SF_LETTERS.map((l) => {
        const href = hrefs[l] ?? null;
        const w = SF_LINK_WORDS[l];
        return href === null ? (
          <span key={l} className="lp-lk lp-lk-none" aria-hidden="true" />
        ) : (
          <a key={l} className="lp-lk" href={href} target="_blank" rel="noopener noreferrer" title={w.title} aria-label={w.spoken} data-testid={`sf-${l}`} onClick={(e) => e.stopPropagation()}>
            {l}
          </a>
        );
      })}
    </span>
  );
}
